import { MessageCircle } from "lucide-react";

export const InlineChatLink = ({ testId, visibilityClassName = "sm:hidden" }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={() => window.dispatchEvent(new Event("dcyb:open-chat"))}
    className={`${visibilityClassName} inline-flex min-h-11 items-center gap-2 font-mono-label text-[11px] !tracking-normal text-[#3C4450] hover:text-[#0F141B] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0F141B]`}
  >
    <MessageCircle size={14} aria-hidden="true" />Ask DCYB BOT
  </button>
);